module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_3.e0e4591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_3.png
// module id = Nich
// module chunks = 19